import classNames from 'classnames';
import { type FC } from 'react';

import TeamAvatar from 'app/components/TeamAvatar';
import ExpandableBlock from 'app/components/ExpandableBlock';
// import FloatingModal from 'app/components/FloatingModal';
// import BracketMatchesList from 'app/components/Blocks/BracketsBlock/BracketWithStandings/BracketMatchesList';
import ArrowIcon from 'app/icons/arrow-plain.svg';

import style from './style.module.scss';

interface Props {
  title: string;
  standings: RoundRobinStanding[];
  selectedTeamId: number | null;
  selectTeam: (teamId: number | null) => void;
  type: 'main' | 'tiebreak';
  // matches: TournamentBracketMatch[];
  // videogame: VideogameSlug;
  // videogameTitle: CounterStrikeVersion | null;
}

const StandingTable: FC<Props> = ({
  title,
  standings,
  selectTeam,
  selectedTeamId,
  type
  // matches,
  // videogame,
  // videogameTitle
}) => {
  const handleSelectTeam = (teamId: number) => {
    if (selectedTeamId === teamId) {
      selectTeam(null);
    } else {
      selectTeam(teamId);
    }
  };

  return (
    <ExpandableBlock title={title} position="bottom">
      <div className={style.standingTable}>
        {standings.map((standing, index) => {
          const selectable = standing.opponent.slug !== 'tbd';
          const selected = selectedTeamId === standing.opponent.id;
          // const matchesForOpponent = matches.filter(match =>
          //   match.opponents.some(opponent => opponent.id === standing.opponent.id)
          // );
          return (
            <button
              key={`${title}_${index}`}
              onClick={() => handleSelectTeam(standing.opponent.id)}
              className={style.selectingTeamContainer}
              type="button"
              disabled={!selectable}
            >
              {/* <FloatingModal
                content={
                  <BracketMatchesList
                    matches={matchesForOpponent}
                    videogame={videogame}
                    videogameTitle={videogameTitle}
                  />
                }
                className={style.floatingModalContainer}
                withPortal
              > */}
              <div
                className={classNames(style.standing, {
                  [style.selectedTeam]: selected
                })}
              >
                <div>{standing.rank}</div>
                <div className={style.opponentIdentification}>
                  <TeamAvatar team={standing.opponent} />
                  <span className={style.opponentName}>{standing.opponent.name}</span>
                </div>
                <div className={style.scoresContainer}>
                  <div>
                    <span>{standing.stats.match_wins}</span>-
                    {type === 'main' && (
                      <>
                        <span>{standing.stats.match_draws}</span>-
                      </>
                    )}
                    <span>{standing.stats.match_losses}</span>
                  </div>
                  {type === 'main' && (
                    <div>
                      <span>{standing.stats.game_wins}</span>-
                      <span>{standing.stats.game_losses}</span>
                    </div>
                  )}
                </div>
                {selected && <ArrowIcon className={style.arrowIcon} />}
              </div>
              {/* </FloatingModal> */}
            </button>
          );
        })}
      </div>
    </ExpandableBlock>
  );
};

StandingTable.displayName = 'StandingTable';

export default StandingTable;
